import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    taskId: Number,
    updateUrl: String 
  }

  connect() {
    // タスクが表示された時に通知更新リクエストを送信
    this.updateNotifications()
  }

  async updateNotifications() {
    try {
      const response = await fetch(this.updateUrlValue, {
        method: 'PATCH',
        headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'X-CSRF-Token': this.getCsrfToken()
        }
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      }
    } catch (error) {
      console.error('通知更新エラー:', error)
    }
  }

  getCsrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.getAttribute('content') : ''
  }
}